/************************************汇聚服务配置URL*********************************/
var configs = JSON.parse(window.localStorage.getItem('configs')) || {};

/*if (!configs) {
    $.ajax({
        type: 'get',
        async: false,
        url: "/to-analysis/all/config",
        contentType: "application/json;charset=UTF-8",
        dataType: 'json',
        success: function (data) {
            if (data.commonResponse.success) {
                configs = data.configMap;
                window.localStorage.setItem("analysis_configs", JSON.stringify(configs));
            } else {
                boxMessage("error", data.commonResponse.errorDesc);
            }
        }
    });
}*/

//公有云配置服务地址
var pubOperateUrl = configs.zuulServerUrl;
//公有云数据查询服务地址
var pubClueUrl = configs.zuulServerUrl;
//台内服务地址
var newsplatformUrl = configs.localClueUrl;
//爬取服务地址
var spiderUrl = configs.SpiderUrl;

//马魁的接口地址
//pubOperateUrl = '//10.10.0.181';

//北京测试环境地址
//pubOperateUrl = '//123.127.220.171:8120';

var sysResources = pubOperateUrl + 'platformConfig/resources/';

var resourceGroupId = 'bs_door'; // 所有门户的动态资源id的前缀

var resourcesTemp = 'tenantResource'; // 租户动态资源的缓存名

var resourceBlocksGroupId = 'bs_door_blocks'; // 门户的版块动态资源的分组id

var resourceButtonsGroupId = 'bs_door_buttons'; //  门户的按钮动态资源的分组id

/*推荐新闻相关接口*/
//3.1要闻频道栏目信息获取
var newsRecommendColumnsUrl = pubOperateUrl + '/cluegather/v3/user/column/list'; //get
//新增查询所有频道的接口，不区分栏目
var newsRecommendAllChannelsUrl =
  pubOperateUrl + '/cluegather/v3/baseData/channel/list'; //get
//3.2根据栏目的具体频道源获取推荐新闻,见11.通用的线索查询接口
//3.3获取系统中的所有的栏目
var newsRecommendAllColumnsUrl =
  pubOperateUrl + '/cluegather/v3/system/column/list'; //get
//3.4用户栏目频道来源修改
var newsRecommendChangeColumnUrl =
  pubOperateUrl + '/cluegather/v3/user/column/'; //put 后面需要拼接频道columnId
//3.5自定义栏目新增
var newsRecommendAddColumnUrl =
  pubOperateUrl + '/cluegather/v3/user/column/add'; //post
//3.6自定义栏目删除
var newsRecommendDelColumnUrl = pubOperateUrl + '/cluegather/v3/user/column/'; //DELETE 后面需要拼接频道columnId
//3.7栏目展示位置交换
var exchangePositionUrl = pubOperateUrl + '/cluegather/v3/user/column/'; //patch
//3.8首页新闻排行 -- 站点信息获取
var newsRankingSitesUrl = pubOperateUrl + '/cluegather/v3/rank/siteList'; //get
//3.9首页新闻排行 -- 排行类型获取
var newsRankingTypesUrl = pubOperateUrl + '/cluegather/v3/rank/typeList'; //get
//3.10首页新闻排行 -- 排行条目获取
var newsRankingContentUrl = pubOperateUrl + '/cluegather/v3/rank/'; //get 后面需要拼接排行站点名称siteId和排行榜类型type
//3.11订阅推荐新闻获取
var mySubscribeContentUrl = pubOperateUrl + '/cluegather/v3/news/subscribe/'; //get 后面需要拼接媒体类型mediaType
//3.12默认展示地域获取
var areaNewsDefaultRegionUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/area/default'; //get
//3.13当天地域新闻统计信息获取
var areaNewsCountInfoUrl = pubOperateUrl + '/cluegather/v3/news/areaCount'; //get
//3.14地域新闻更多获取,见11.通用的线索查询接口
//3.15新闻详情信息获取
var newsDetailUrl = pubOperateUrl + '/cluegather/v3/news/'; //get 后面需要拼接线索resourceId
//3.17基于用户画像的线索推荐
var recommendNewsListUrl = pubOperateUrl + '/cluegather/v3/news/recommend'; //get

/*订阅新闻相关接口*/
//4.1获取订阅媒体类型配置信息
var subNewsMediaTypeUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/mediaType/list'; //get
//4.2获取用户订阅站点配置信息
var subNewsSitesUrl = pubOperateUrl + '/cluegather/v3/subscribe/account/list'; // get 后面需要拼接媒体类型mediaType
//4.3获取订阅内容分类列表
var subNewsContentClassifyUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/contentClassify/list'; //get
//4.4获取用户订阅地域信息
var subNewsRegionClassifyUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/area/list'; //get
//5.1保存常用标签
var subNewsSaveLabelUrl = pubOperateUrl + '/cluegather/v3/queryCondition/save'; //post
//5.2查询所有常用标签
var subNewsFindLabelsUrl = pubOperateUrl + '/cluegather/v3/queryCondition/list'; //get
//5.3删除常用标签
var subNewsDelLabelUrl = pubOperateUrl + '/cluegather/v3/queryCondition/'; //DELETE 后面需要拼接标签conditionId
//5.4交换常用标签展示位置（暂不实现）
var changeSubNewsLabelPositionUrl =
  pubOperateUrl + '/cluegather/v3/queryCondition/'; //PATCH
//5.5根据常用标签进行查询,见11.通用的线索查询接口
//6.1获取所有媒体类型信息
var subNewsAllMediaTypeUrl =
  pubOperateUrl + '/cluegather/v3/system/mediaType/list'; //get
//6.2新增媒体类型订阅
var subNewsAddMediaTypeUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/mediaType/add'; //post
//6.3获取系统媒体类型和用户订阅状况
var subNewsAllMediaTypeAndUserUrl =
  pubOperateUrl + '/cluegather/v3/systemUser/mediaType'; //get
//6.4取消媒体订阅
var subNewsCancelMediaUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/mediaType/'; //DELETE 后面需要拼接媒体类型mediaType
//6.5交换两媒体订阅展示位置
var exchangeMediaPositionUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/mediaType/'; //patch
//6.6获取所有内容分类信息
var subNewsAllContentClassifyUrl =
  pubOperateUrl + '/cluegather/v3/system/contentClassify/list'; //get
//6.7新增用户内容分类订阅
var subNewsAddContentClassifyUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/contentClassify/add'; //post
//6.8获取系统内容分类及用户订阅状况（新增）
var subNewsAllContentClassifyAndUserUrl =
  pubOperateUrl + '/cluegather/v3/systemUser/contentClassify'; //get
//6.9删除内容分类订阅
var subNewsDelContentClassifyUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/contentClassify/'; //DELETE 后面需要拼接内容分类contentClassifyId
//6.10交换两内容分类订阅展示位置
var exchangeContentPositionUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/contentClassify/'; //patch
//6.11获取指定媒体类型下站点分组信息
var subNewsMediaUnderClassifyUrl =
  pubOperateUrl + '/cluegather/v3/baseData/types/'; //get 后面需要拼接媒体类型mediaType
//6.12根据分组信息获取分组下所有站点信息
var subNewsClassifyUnderSiteUrl =
  pubOperateUrl + '/cluegather/v3/baseData/list/'; //get 后面需要拼接媒体类型mediaType
//6.13根据分组获取分组下所有站点信息及用户订阅情况（新增）
//var subNewsClassifyUnderAllSiteAndUserUrl = pubOperateUrl + '/cluegather/v3/baseDataUser/list/'; //get 后面需要拼接媒体类型mediaType
var subNewsClassifyUnderAllSiteAndUserUrl =
  pubOperateUrl + '/cluegather/v3/baseDataUser/list-user/'; //get 后面需要拼接媒体类型mediaType
//6.14取消站点订阅
var subNewsCancelSitesUrl = pubOperateUrl + '/cluegather/v3/subscribe/account/'; //DELETE 后面需要拼接媒体类型mediaType/站点来源accountId
//6.15搜索站点,暂无
//6.16新增站点订阅
var subNewsAddSitesUrl = pubOperateUrl + '/cluegather/v3/subscribe/account/add'; //POST
//6.17交换两订阅站点展示位置
var exchangePositionUrl = pubOperateUrl + '/cluegather/v3/subscribe/account/'; //patch
//6.18获取所有的地域范围
var subNewsAllRegionUrl = pubOperateUrl + '/cluegather/v3/system/area/'; //get 后面需要拼接父级parentAreaId
//6.19获取用户订阅的地域范围，参见 4.4 获取用户订阅地域信息
//6.20获取系统的地域范围及用户订阅情况 - （新增）
var subNewsAllRegionAndUserUrl =
  pubOperateUrl + '/cluegather/v3/systemUser/area'; //GET
//6.21删除地域订阅
var subNewsDeleteRegionUrl = pubOperateUrl + '/cluegather/v3/subscribe/area/'; //DELETE 后面需要拼接areaId
//6.22新增地域订阅
var subNewsAddRegionUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/area/multiAdd'; //post
//6.23交换两地域订阅位置
var exchangeAreaPositionUrl = pubOperateUrl + '/cluegather/v3/subscribe/area/'; //post
//6.24批量删除地域订阅
var subNewsDeleteLotRegionUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/area/multi/'; //DELETE 后面需要拼接areaId
//6.26 获取所有安全事件分类信息
var getSecurityEventVarietyUrl =
  pubOperateUrl + '/cluegather/v3/system/secureEventClassify/list';
//6.27 用户是否已经初始化判断
var userInitTestUrl = pubOperateUrl + '/cluegather/v3/subscribe/init/check';
//6.28用户初始化地域及新闻类型订阅
var subscribeAreaClassifieUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/init/area-classifies';
//6.29搜索相关帐号
var searchAccountUrl = pubOperateUrl + '/cluegather/v3/baseData/search';
//6.30帐号订阅
var subscribeAccountsUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/init/accounts';
//6.31租户帐号获取
var tenantAccountUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/init/tenant-accounts';
//6.32获取用户订阅站点及媒体类型信息
var subscribedResourceListUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/account-mediaType/list';
//6.33取消站点订阅，同步媒体类型订阅
var deleteAccountUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/account-mediaType/';
//6.34新增站点订阅，同步媒体类型订阅
var addAccountUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/account-mediaType/add';
//6.35省市地域查询
var searchAreaUrl = pubOperateUrl + '/cluegather/v3/system/area-search/';

//7.1根据条件查询新闻列表（带分页，是否收藏）,参见公共统一的新闻查询接口
//7.2添加/取消新闻收藏
var subNewsAddOrCancelcollect = pubOperateUrl + '/cluegather/v3/favorite/'; //PATCH 后面需要拼接线索resourceId/是收藏还是取消收藏mode
//7.3相关线索,参见公共统一的新闻查询接口
//7.4 根据资源id删除线索
var removeResouceByIdUrl = pubOperateUrl + '/cluegather/v3/news/'; //delete
//8.1用户收藏查询接口（带分页）
var subNewsFindCollectUrl = pubOperateUrl + '/cluegather/v3/favorite/search'; //post
//8.2查询用户我的跟踪
var subNewsFindMyFollowUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/tracker/list'; //get
//8.3创建我的跟踪
var subNewsCreateMyFollowUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/tracker/add'; //post
//8.4删除我的跟踪
var subNewsDeleteMyFollowUrl =
  pubOperateUrl + '/cluegather/v3/subscribe/tracker/'; //DELETE 后面需要拼接我的跟踪trackerId
//8.5用户抓取查询接口（带分页） （待确定）
//8.6我的收藏详情查询
var subNewsCollectDetailUrl = pubOperateUrl + '/cluegather/v3/favorite/'; //get 后面需要拼接我的收藏favoriteId
//8.7根据id查询用户我的跟踪
var myTraceUrl = pubOperateUrl + '/cluegather/v3/subscribe/tracker/'; //get 后面需要拼接trackerId
//8.8更新我的跟踪的上一次查询时间
var myTraceLastTimeUrl = pubOperateUrl + '/cluegather/v3/subscribe/tracker/'; //PATCH 后面需要拼接trackerId

/*台内线索相关接口*/
//9.2热线电话查询（带分页）
var internalClueHotlineListUrl = newsplatformUrl + 'api/phonehotline/list'; //post
//9.3热点电话线索修改（暂不提供）
//9.4热点电话/新闻报料线索上传
var internalClueAddUrl =
  newsplatformUrl + 'CCResourceInfoController/addCCResourceInfo'; //post
//9.5新闻报料查询（带分页）
var internalClueClueListUrl = newsplatformUrl + 'api/newsbaoliao/list'; //post
//9.6新闻报料线索修改（暂不提供）
//9.7台内线索添加收藏
var internalClueAddCollectUrl = newsplatformUrl + 'collections/collection/'; //post 后面需要拼接resourceGuid
//9.8台内线索删除收藏
var internalClueDeleteCollectUrl = newsplatformUrl + 'collections/collection/'; //post 后面需要拼接resourceGuids(支持多个id)
//9.9台内线索收藏的查询
var internalClueCollectListUrl = newsplatformUrl + 'collections/collection/';
//9.10台内线索详情查询
var internalClueDetailUrl = newsplatformUrl + 'api/common/'; //get 后面需要拼接资源resourceGuid
//9.111查询tab栏
var checkInternalTabsUrl = newsplatformUrl + 'config/getSysInfo4Nav';

// 通用的第三方查询接口路径
var localCommonSearchUrl = newsplatformUrl + 'resource/search'; // post

/*10高级搜索接口（我的跟踪）*/
var advancedSearch = pubOperateUrl + '/cluegather/v3/news/searchPlus'; //post

/*11通用的线索搜索接口*/
var generalSearch = pubOperateUrl + '/cluegather/v3/news/search'; //post

//13.1获取系统支持的元搜索引擎信息
var networkSearchMsgUrl = pubOperateUrl + '/cluegather/v3/meta-search/engines'; //get

//13.2执行元搜索
var networkSearchUrl = pubOperateUrl + '/cluegather/v3/meta-search/search/'; //get

//14.1首页栏目新闻聚合接口
var indexRecommendNewsUrl =
  pubOperateUrl + '/cluegather/v3/news/index-column-news'; //get
var newIndexRecommendNewsUrl =
  pubOperateUrl + '/cluegather/v3/news/index-column-all-news';

//14.2首页新闻排行聚合返回接口
var indexRankingNewsUrl = pubOperateUrl + '/cluegather/v3/rank/index'; //get

//14.3首页新闻站点排行批量查询聚合接口
var rankingNewsUrl = pubOperateUrl + '/cluegather/v3/rank/multi/'; //get

//14.4首页订阅新闻聚合接口
var indexSubscribeNewsUrl =
  pubOperateUrl + '/cluegather/v3/news/index-subscribe-news'; //get

//15.1文档模版新增接口
var addDocModuleUrl = pubOperateUrl + '/cluegather/v3/template/add';

//15.2文档模版删除接口
var deleteDocModuleUrl = pubOperateUrl + '/cluegather/v3/template/';

//15.3文档模版详情获取接口
var detailDocModuleUrl = pubOperateUrl + '/cluegather/v3/template/';

//15.4文档模版更新接口
var updateDocModuleUrl = pubOperateUrl + '/cluegather/v3/template/';

//15.5文档模版分页获取接口
var docModuleListUrl = pubOperateUrl + '/cluegather/v3/template/list';

//16.1素材新增接口
var addMaterialUrl = pubOperateUrl + '/cluegather/v3/material/add/';

//16.2素材删除接口
var deleteMaterialUrl = pubOperateUrl + '/cluegather/v3/material/';

//16.3素材详情获取接口
var detailMaterialUrl = pubOperateUrl + '/cluegather/v3/material/';

//16.4素材状态更新为已使用接口
var changeMaterialStateUrl = pubOperateUrl + '/cluegather/v3/material/';

//16.5素材分页获取接口
var materialListUrl = pubOperateUrl + '/cluegather/v3/material/list';

//17.1图文保存接口
var saveProduceUrl = pubOperateUrl + '/cluegather/v3/document/draft';

//17.2图文发布接口
var publishProduceUrl = pubOperateUrl + '/cluegather/v3/document/release';

//17.3图文删除接口
var deleteProduceUrl = pubOperateUrl + '/cluegather/v3/document/';

//17.4图文详情获取接口
var detailProduceUrl = pubOperateUrl + '/cluegather/v3/document/';

//17.5图文分页获取接口
var produceListUrl = pubOperateUrl + '/cluegather/v3/document/list';

/*热点发现相关接口--服务*/
//3.1热点事件查询接口
var hotEventsCheckUrl = pubOperateUrl + '/hotspot/v1/events/list'; //post
var newHotEventsCheckUrl = pubOperateUrl + '/hotspot/v1/hot-event/list-new'; //post

//3.2事件类型的事件热词查询接口
var eventTypeHotWordsCheckUrl =
  pubOperateUrl + '/hotspot/v1/events/hotwords/list/'; //get

//3.3事件类型获取接口
var eventTypeCheckUrl = pubOperateUrl + '/hotspot/v1/events/classify/list'; //get

//3.4地域热点事件地图统计接口
var mapDateCheckUrl = pubOperateUrl + '/hotspot/v1/events/areaHeat'; //get

//3.5热点事件查询接口
var hotEventsListFirstUrl = pubOperateUrl + '/hotspot/v1/events/list-first'; //post

//3.6检查下载事件跟踪分析结果
var checkDownloadEventTraceUrl =
  pubOperateUrl + '/hotspot/v1/events/file/download-check/'; //get

//3.7上传事件跟踪分析图片并且与事件分析列表一并压缩
var uploadEventTraceUrl = pubOperateUrl + '/hotspot/v1/events/file/upload/'; // get

//3.8下载事件跟踪分析结果
var downloadEventTraceUrl = pubOperateUrl + '/hotspot/v1/events/file/download/';

//4.1事件类型的基本信息查询
var eventTypeInfoCheckUrl = pubOperateUrl + '/hotspot/v1/event/profile/'; //get 后面需拼接eid

//4.2事件热度趋势查询
var eventHotTrendCheckUrl = pubOperateUrl + '/hotspot/v1/event/yuqing-trend/'; //get 后面需拼接eid和传递其他参数

//4.3获取事件中文章类型分布
var articleTypeOfEventUrl = pubOperateUrl + '/hotspot/v1/event/content-type/'; //get 后面需拼接eid和传递其他参数

//4.4获取事件的相关热词
var relatedHotWordsOfEventUrl = pubOperateUrl + '/hotspot/v1/event/hot-words/'; //get 后面需拼接eid和传递其他参数

//4.5获取事件中重要文章
var importantArticleOfEventUrl =
  pubOperateUrl + '/hotspot/v1/event/important-news/'; //get 后面需拼接eid和传递其他参数

//4.6获取事件中媒体传播分布
var mediaSpreadOfEventUrl = pubOperateUrl + '/hotspot/v1/event/news-media/'; //get 后面需拼接eid和传递其他参数

//4.7获取事件中活跃媒体
var activeMediaOfEventUrl = pubOperateUrl + '/hotspot/v1/event/active-media/'; //get 后面需拼接eid和传递其他参数

//4.8获取事件发布热区
var pubHotAreaUrl = pubOperateUrl + '/hotspot/v1/event/hot-pub-area/'; //get 后面需拼接eid和传递其他参数

//4.9获取事件提及热区
var referHotAreaUrl = pubOperateUrl + '/hotspot/v1/event/hot-refer-area/'; //get 后面需拼接eid和传递其他参数

//4.10获取事件情感属性
var emotionTypeOfEventUrl = pubOperateUrl + '/hotspot/v1/event/emotion-attr/'; //get 后面需拼接eid和传递其他参数

//4.11获取事件情感趋势
var emotionTrendOfEventUrl = pubOperateUrl + '/hotspot/v1/event/emotion-trend/'; //get 后面需拼接eid和传递其他参数

//4.12微信分析--获取热门公众号
var weixinHotAccountCheckUrl = pubOperateUrl + '/hotspot/v1/event/wx-account/'; //get 后面需拼接eid和传递其他参数

//4.13微信分析--获取热点指数（WCI）分布
var weixinWCICheckUrl = pubOperateUrl + '/hotspot/v1/event/wx-wci/'; //get 后面需拼接eid和传递其他参数

//4.14微信分析--获取账号类型分布
var weixinAccountTypeCheckUrl =
  pubOperateUrl + '/hotspot/v1/event/wx-account-type/'; //get 后面需拼接eid和传递其他参数

//4.15微信分析--获取文章位置分布
var weixinArticlePlaceUrl = pubOperateUrl + '/hotspot/v1/event/wx-position/'; //get 后面需拼接eid和传递其他参数

//4.16微博分析--获取热门微博号
var weiboHotAccountUrl = pubOperateUrl + '/hotspot/v1/event/weibo-account/'; //get 后面需拼接eid和传递其他参数

//4.17微博分析--获取微博账号的认证分布
var weiboAuthenticationUrl =
  pubOperateUrl + '/hotspot/v1/event/weibo-cert-type/'; //get 后面需拼接eid和传递其他参数

//4.18微博分析--获取账号质量分布
var weiboAccountQualityUrl =
  pubOperateUrl + '/hotspot/v1/event/weibo-fans-quality/'; //get 后面需拼接eid和传递其他参数

//4.19微博分析--获取账号性别分布
var weiboAccountGenderUrl =
  pubOperateUrl + '/hotspot/v1/event/weibo-account-sex/'; //get 后面需拼接eid和传递其他参数

//4.20获取相关推荐事件
var relatedEventsUrl = pubOperateUrl + '/hotspot/v1/event/related-events/'; //get 后面需拼接eid

//4.21获取事件热词走势
var hotWordsTrendOfEventUrl =
  pubOperateUrl + '/hotspot/v1/event/hot-words-trend/'; //get 后面需拼接eid和传递其他参数

//4.22获取事件的文章列表
var articleListOfEventUrl = pubOperateUrl + '/hotspot/v1/event/event-news/'; //post 后面需拼接eid和传递其他参数

//4.23获取文章详情
var articleDetailUrl = pubOperateUrl + '/hotspot/v1/news/news-detail/'; //get 后面需拼接news_uuid

//4.24下载检查事件分析结果
var checkDownloadHotEventUrl =
  pubOperateUrl + '/hotspot/v1/event/file/download-check/'; //get

//4.25上传事件分析图片并且与事件分析列表一并压缩
var uploadHotEventUrl = pubOperateUrl + '/hotspot/v1/event/file/upload/'; //post

//4.26下载检查事件跟踪分析结果
var downloadHotEventUrl = pubOperateUrl + '/hotspot/v1/event/file/download/'; //get

//5.1微信榜单的查询接口
var weixinListUrl = pubOperateUrl + '/hotspot/v1/wechatRank/list'; //post

//5.2微信榜单媒体类型查询接口
var weixinMediaTypeUrl = pubOperateUrl + '/hotspot/v1/wechatRank/classify/list'; //get

//6.1账号详情--获取榜单中某个公众号的概况
var accountDetailSurveyUrl = pubOperateUrl + '/hotspot/v1/wx-account/survey/'; //get 后面需拼接wid

//6.2账号详情--获取榜单中某个公众号的运营数据趋势
var accountDetailOperateTrendUrl =
  pubOperateUrl + '/hotspot/v1/wx-account/rank-trend/'; //get 后面需拼接wx_biz/start_date/end_date

//6.3通过微信id获取同主体账号列表
var sameAccountListByWeixinIdUrl =
  pubOperateUrl + '/hotspot/v1/wx-account/similar/'; //get

//6.4通过微信id获取近多少天的发布数据
var AccountRankingTrendByWxIdUrl =
  pubOperateUrl + '/hotspot/v1/wx-account/publish-data/'; //get

//6.5通过微信biz获取账号动态数据
var accountStatusByWxBizUrl = pubOperateUrl + '/hotspot/v1/wx-account/dynamic/'; //get

//6.6通过微信biz以及日期获取文章列表信息
var ArticleListByWxBizUrl = pubOperateUrl + '/hotspot/v1/wx-account/articles/'; //get

//6.7通过微信昵称微信号微信id进行搜索
var searchByWxAccountUrl = pubOperateUrl + '/hotspot/v1/wx-account/search/'; //get

//6.8暂无

//6.9暂无

//6.10账号详情--获取榜单中某个公众号的最近发布的文章
var recentArticleOfAccountUrl =
  pubOperateUrl + '/hotspot/v1/wechatDetail/articles/'; //get

//7.1微博榜单的查询接口
var weiboListUrl = pubOperateUrl + '/hotspot/v1/weiboRank/list'; //post

//8.1头条榜单的查询接口
var headlineListUrl = pubOperateUrl + '/hotspot/v1/toutiaoRank/list'; //post

//9.1热搜榜单的查询接口
var hotSearchUrl = pubOperateUrl + '/hotspot/v1/hotSearch/'; //get 后面需拼接siteId、classify和其他传参

//9.2热搜榜类型获取接口
var hotSearchTypeUrl = pubOperateUrl + '/hotspot/v1/hotSearch/classify/'; //get 后面需拼接siteId

//9.3热搜榜类型订阅设置
var subscribeSearchType =
  pubOperateUrl + '/hotspot/v1/hotSearch/classify-subscribe/'; //post

//10.1推荐热点事件获取
var recommendHotEventUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-hot-events'; //get 后面需传递参数size

//10.2推荐热词获取
var recommendHotWordUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-hot-words'; //get 后面需传递参数size

//10.3推荐微信榜单获取
var recommendWeixinListUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-wechat-ranks/'; //get 后面需拼接billboard_time和其他传参

//10.4推荐微博榜单获取
var recommendWeiboListUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-weibo-ranks/'; //get 后面需拼接billboard_time和其他传参

//10.5推荐头条榜单获取
var recommendHeadlineListUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-toutiao-ranks/'; //get 后面需拼接billboard_time和其他传参

//10.6推荐热文获取
var recommendHotArticleUrl =
  pubOperateUrl + '/hotspot/v1/index/recommend-hot-infos/'; //get 后面需拼接type和其他传参

//11.1获取系统中榜单入库日期
var billboardTimeGetUrl = pubOperateUrl + '/hotspot/v1/other/billboard-time'; // get

//11.2统一的查询
var generalSearchUrl = pubOperateUrl + '/hotspot/v1/other/search/'; //get

//12.1获取榜单列表
var getListUrl = pubOperateUrl + '/hotspot/v1/user-billboard/list/'; //get

//12.2修改自定义榜单
var changeCustomListUrl = pubOperateUrl + '/hotspot/v1/user-billboard/'; //put

//12.3删除自定义榜单
var deleteCustomListUrl = pubOperateUrl + '/hotspot/v1/user-billboard/'; //DELETE

//12.4新增自定义榜单
var customListUrl = pubOperateUrl + '/hotspot/v1/user-billboard/add'; //post

//12.5自定义榜单帐号查询（微信、微博、头条）
var customListAccountCheckUrl =
  pubOperateUrl + '/hotspot/v1/user-billboard/account-search/'; //get

//12.6向自定义榜单中添加帐号（支持批量操作）
var addAccountInCustomListUrl =
  pubOperateUrl + '/hotspot/v1/user-billboard/account-add/'; //post

//12.7从自定义榜单中移除帐号（支持批量操作）
var deleteAccountInCustomListUrl =
  pubOperateUrl + '/hotspot/v1/user-billboard/account-delete/'; //delete

//12.8从自定义榜单中移动帐号到其他自定义榜单
var moveAccountUrl = pubOperateUrl + '/hotspot/v1/user-billboard/account-move/'; //get

//13.1素材新增接口
var addMaterialUrl = pubOperateUrl + '/hotspot/v1/material/add/';

//13.2素材删除接口
var deleteMaterialUrl = pubOperateUrl + '/hotspot/v1/material/';

/*热点发现相关接口--聚合*/
//2.1 热门新闻列表查询接口
var hotNewListCheckUrl = pubOperateUrl + '/hotspot/v1/news-group/list'; //post

//2.2 文章详情查询接口
var articleDetailCheckUrl = pubOperateUrl + '/hotspot/v1/hotnews/details/'; //get

//3.1 热词列表查询接口
var hotWordListCheckUrl = pubOperateUrl + '/hotspot/v1/hotword/list'; //get

//3.2 热词热度趋势查询接口
var hotWordTrendCheckUrl = pubOperateUrl + '/hotspot/v1/hotword/hot-tendency/'; //get

//3.3 关联分析查询接口（待补充）
var hotWordRelationChecUrl =
  pubOperateUrl + '/hotspot/v1/hotword/hot-relation/'; //get

//3.4 热词相关文章查询接口
var hotWordRelatedArticlesUrl =
  pubOperateUrl + '/hotspot/v1/hotword/hot-related-articles/'; //get

//3.5 热词排除接口
var deleteHotWordUrl = pubOperateUrl + '/hotspot/v1/hotword/exclude/'; //delete

//4.1 用户关注的热点事件查询接口
var checkUserHotEventsUrl =
  pubOperateUrl + '/hotspot/v1/user-concerned/hotevent'; //get

//4.2 用户关注的热点事件删除接口
var deleteUserHotEventsUrl =
  pubOperateUrl + '/hotspot/v1/user-concerned/hotevent/'; //delete

//4.3用户关注的公众号查询接口
var checkUserAccountUrl = pubOperateUrl + '/hotspot/v1/user-concerned/accounts'; //get

//4.4 用户关注的公众号删除接口
var deleteUserAccountUrl =
  pubOperateUrl + '/hotspot/v1/user-concerned/account/'; //delete

//4.5 用户关注的热门新闻查询接口
var checkUserHotNewsUrl = pubOperateUrl + '/hotspot/v1/user-concerned/hotnews'; //post

//4.6用户关注的热门新闻删除接口
var deleteUserHotNewsUrl =
  pubOperateUrl + '/hotspot/v1/user-concerned/hotnews/'; //delete

//5.1 用户跟踪列表查询接口
var eventTraceListUrl = pubOperateUrl + '/hotspot/v1/event-tracker/list'; //post

//5.2 新建事件跟踪接口
var addEventTraceUrl = pubOperateUrl + '/hotspot/v1/event-tracker/add'; //post

//5.3 新闻汇总查询接口
var checkAllNewsUrl = pubOperateUrl + '/hotspot/v1/event-tracker/event-news'; //get

//5.4 事件跟踪修改接口
var changeEventTraceUrl = pubOperateUrl + '/hotspot/v1/event-tracker/'; //put

//5.5 事件跟踪删除接口
var deleteEventTraceUrl = pubOperateUrl + '/hotspot/v1/event-tracker/delete/'; //DELETE

//事件报告图片上传接口
var uploadReportPicUrl = pubOperateUrl + '/hotspot/v1/events/img/upload';

//事件报告pdf下载接口
var downloadPdfReportUrl =
  pubOperateUrl + '/hotspot/v1/events/report/pdf/download';

//6.1 微信公众号收藏新增接口
var wxAccountCollectUrl =
  pubOperateUrl + '/hotspot/v1/user-collect/collected-wx-account'; //post

//6.2 用户热门新闻收藏新增接口
var hotNewsCollectUrl =
  pubOperateUrl + '/hotspot/v1/user-collect/collected-hotnews/'; //post

//6.3 热门事件的收藏接口
var hotEventCollectUrl =
  pubOperateUrl + '/hotspot/v1/user-collect/collected-hotevent/'; //post

//6.1 公众号文章列表数据查询接口
var accountArticleListUrl =
  pubOperateUrl + '/hotspot/v1/user-billboard/account-news/';

//6.2 导出文章列表数据接口
var downloadAccountArticleListUrl =
  pubOperateUrl + '/hotspot/v1/user-billboard/account-news/export/';

//4.2.1新增用户消息提醒策略
var addNotifyPolicyUrl = pubOperateUrl + '/msgnotify/v1/policy/add';

//4.2.1查询用户消息提醒策略
var searchNotifyPolicyUrl = pubOperateUrl + '/msgnotify/v1/policy/search';

//4.2.1更新用户消息提醒策略
var updateNotifyPolicyUrl = pubOperateUrl + '/msgnotify/v1/policy/update/';

//4.3.1用户消息提醒方式——新增
var addNotifywayUrl = pubOperateUrl + '/msgnotify/v1/way/add';

//4.3.2用户消息提醒方式——查询
var searchNotifywayUrl = pubOperateUrl + '/msgnotify/v1/way/search';

//4.3.3用户消息提醒方式——更新
var updateNotifywayUrl = pubOperateUrl + '/msgnotify/v1/way/update/';

// 18.1 查询租户首页配置模块接口
var getIndustryModuleConfigUrl =
  pubOperateUrl + '/operatemanager/v3/home-page/module/tenant/';

// 30.14用户通知消息查询
let panelTipMsgUrl = pubOperateUrl + '/message/v1/user-tip-msg/list-user';

// 获取视频榜单
let videoSearchUrl = pubOperateUrl + '/video-core/v1/video-resource/search';

// 新热词搜索
let newsHotWordSearchUrl =
  pubOperateUrl + '/cluegather/v3/news/search-keywords';
let leaderHotWordSearchUrl =
  pubOperateUrl + '/cluegather/v3/news/leader/news-list-keywords';

// 获取行业详情
let getIndustryDetailUrl = pubOperateUrl + '/operatemanager/v3/system-industry/detail/'

// 获取行业主题
let getTopicDetailUrl =
  pubOperateUrl + '/operatemanager/v3/industry-topic/detail/';

// 30.2已用看板帐号查询
let panelUsedAccountUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/user-panel-account-ids';

// 30.4用户看板及对应帐号查询
let panelAccountListUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/panel-account-list';

// 30.5用户看板详情查询
let panelDetailUrl = pubOperateUrl + '/cluegather/v3/user-panel/detail/';

// 30.6用户看板删除
let deletePanelUrl = pubOperateUrl + '/cluegather/v3/user-panel/';

// 30.7用户看板新增
let addPanelUrl = pubOperateUrl + '/cluegather/v3/user-panel/add';

// 30.8用户看板修改
let updatePanelUrl = pubOperateUrl + '/cluegather/v3/user-panel/update/';

// 30.9用户看板总量
let panelCountUrl = pubOperateUrl + '/cluegather/v3/user-panel/panel-count';

// 30.10用户看板提醒状态开启
let updatePanelStatusUrl = pubOperateUrl + '/cluegather/v3/user-panel/';

// 30.11用户看板排序调整
let sortPanelUrl = pubOperateUrl + '/cluegather/v3/user-panel/sequence-change';

// 30.12用户看板排序调整
let moveTopPanelUrl = pubOperateUrl + '/cluegather/v3/user-panel/move-top/';

// 30.15用户看板初始化
let panelInitUrl = pubOperateUrl + '/cluegather/v3/user-panel/init';

// 30.16用户看板引导板状态查询
let panelRecommendStatusUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/guide-show';

// 30.17用户看板引导板状态变动
let updatePanelRecommendStatusUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/guide-show/';

//5.4获取指定媒体类型下站点分组信息
var typeOfmediaTypeUrl = pubOperateUrl + '/operatemanager/v3/baseData/types/'; //get 后面需拼接mediaType

// 30.18跟踪看板情感趋势
let trackerPanelEmotionTrendUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/emotion-trend/';

// 30.19跟踪看板帐号趋势
let trackerPanelAccountTrendUrl =
  pubOperateUrl + '/cluegather/v3/user-panel/account-trend/';

// 专题检索接口
let specialTopicSearchUrl = pubOperateUrl + '/hotspot/v1/special-topic/search/';

// 专题列表接口
let specialTopicPageUrl = pubOperateUrl + '/hotspot/v1/special-topic/page';

// 2专题详情接口
let specialTopicDetailUrl = pubOperateUrl + '/hotspot/v1/special-topic/detail/';

// 历史图谱
let todayOnHistorySearchUrl = pubOperateUrl + '/knowledge/v1/today-on-history/search/';

// 1查询运营日历
let operationCalendarListUrl = pubOperateUrl + '/hotspot/v1/operation-calendar/list/';

// 21.1 查询租户重点工作
let tenantKeyWorkListUrl = pubOperateUrl + '/operatemanager/v3/key-work/tenant-list/';

// 21.2 增加重点工作-租户级
let addTenantKeyWorkUrl = pubOperateUrl + '/operatemanager/v3/key-work/add';

// 21.3 查看重点工作详情接口
let checkKeyWorkDetailUrl = pubOperateUrl + '/operatemanager/v3/key-work/detail/';

// 21.4 删除租户重点工作接口
let deleteKeyWorkUrl = pubOperateUrl + '/operatemanager/v3/key-work/tenant-delete/';

// 21.5 修改重点工作-租户级
let updateKeyWorkUrl = pubOperateUrl + '/operatemanager/v3/key-work/tenant-update/';

// 22.5 重点工作排序
let sortKeyWorkUrl = pubOperateUrl + '/operatemanager/v3/key-work/sort/';

// 获取数据类型
let matchDataTypeUrl = pubOperateUrl + '/operatemanager/v3/data-type/match-data-type';

// 获取匹配类型
let dataTypeFieldUrl = pubOperateUrl + '/operatemanager/v3/data-type/data-type-fields';

// 媒体等级
let mediaLevelUrl = pubOperateUrl + '/operatemanager/v3/baseData/media-level';

// 1.1添加媒体报道主题配置
let addMediaReportConfigureUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/add';

// 1.2查询媒体报道主题配置
let checkMediaReportConfigureUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/search';

// 1.3删除媒体报道主题配置
let deleteMediaReportConfigureUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/delete/';

// 1.4更新媒体报道主题配置
let updateMediaReportConfigureUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/update/';

// 1.5查询媒体报道主题详情
let checkMediaReportConfigureDetailUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/detail/';

// 1.6查询主题相关的媒体报道测试验证接口
let testMediaReportConfigureUrl = pubOperateUrl + '/propagationcore/v1/media_report/configure/article/verify';

// 2.1查询媒体报道文章
let mediaReportArticleSearchUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/search';

// 2.2删除媒体报道文章
let deleteMediaReportArticleUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/delete/';

// 2.3修改媒体报道文章
let updateMediaReportArticleUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/update/';

// 2.6添加媒体报道文章
let addMediaReportArticleUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/add';

// 2.4导出媒体报道文章
let exportMediaReportArticleUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/export';

// 2.5导入媒体报道文章
let importMediaReportArticleUrl = pubOperateUrl + '/propagationcore/v1/media_report/article/import';

// 获取系统媒体类型
let systemMediaTypeUrl = pubOperateUrl + '/operatemanager/v3/enum-item/media-type';

// 获取租户主题
let checkTenantIndustryTopicListUrl = pubOperateUrl + '/operatemanager/v3/industry-topic/tenant-list/';

// 获取电气热点新闻列表
let checkHotspotNewsListUrl = pubOperateUrl + '/cluegather/v3/industry/reduce/hot/search';

// 获取融媒矩阵媒体账号
let checkMediaAccountListUrl = pubOperateUrl + '/propagationcore/v1/account-channel/list/';

// 获取融媒矩阵新闻列表
let checkMatrixNewsListUrl = pubOperateUrl + '/cluegather/v3/industry/reduce/matrix/search';

// 导出线索新闻列表
let exportClueNewsListUrl = pubOperateUrl + '/cluegather/v3/news/exportSearch';

// 导出融媒矩阵新闻列表
let exportMatrixNewsListUrl = pubOperateUrl + '/propagationcore/v2/industry/reduce/matrix/search/export';

// 导出我的收藏
let exportCollectNewsListUrl = pubOperateUrl + '/cluegather/v3/favorite/export';

// 搜索视频账号
let searchVideoAccountUrl = pubOperateUrl + '/hotspot/v1/user-billboard/account-search-new/';

export default {
  pubOperateUrl,
  billboardTimeGetUrl,
  areaNewsDefaultRegionUrl,
  hotNewListCheckUrl,
  weixinListUrl,
  weiboListUrl,
  headlineListUrl,
  hotWordListCheckUrl,
  hotEventsCheckUrl,
  generalSearch,
  areaNewsCountInfoUrl,
  searchNotifywayUrl,
  addNotifywayUrl,
  updateNotifywayUrl,
  searchNotifyPolicyUrl,
  addNotifyPolicyUrl,
  updateNotifyPolicyUrl,
  eventTypeCheckUrl,
  newHotEventsCheckUrl,
  recommendHotWordUrl,
  getIndustryModuleConfigUrl,
  panelTipMsgUrl,
  recommendHotEventUrl,
  recommendHotArticleUrl,
  videoSearchUrl,
  newsHotWordSearchUrl,
  leaderHotWordSearchUrl,
  getIndustryDetailUrl,
  getTopicDetailUrl,
  panelUsedAccountUrl,
  panelAccountListUrl,
  panelDetailUrl,
  deletePanelUrl,
  addPanelUrl,
  updatePanelUrl,
  panelCountUrl,
  updatePanelStatusUrl,
  sortPanelUrl,
  moveTopPanelUrl,
  panelInitUrl,
  panelRecommendStatusUrl,
  updatePanelRecommendStatusUrl,
  typeOfmediaTypeUrl,
  trackerPanelEmotionTrendUrl,
  trackerPanelAccountTrendUrl,
  subNewsAllRegionUrl,
  subNewsAllMediaTypeUrl,
  searchAccountUrl,
  specialTopicSearchUrl,
  specialTopicPageUrl,
  specialTopicDetailUrl,
  todayOnHistorySearchUrl,
  operationCalendarListUrl,
  tenantKeyWorkListUrl,
  addTenantKeyWorkUrl,
  checkKeyWorkDetailUrl,
  deleteKeyWorkUrl,
  updateKeyWorkUrl,
  sortKeyWorkUrl,
  matchDataTypeUrl,
  dataTypeFieldUrl,
  mediaLevelUrl,
  addMediaReportConfigureUrl,
  checkMediaReportConfigureUrl,
  deleteMediaReportConfigureUrl,
  updateMediaReportConfigureUrl,
  checkMediaReportConfigureDetailUrl,
  testMediaReportConfigureUrl,
  mediaReportArticleSearchUrl,
  deleteMediaReportArticleUrl,
  updateMediaReportArticleUrl,
  addMediaReportArticleUrl,
  exportMediaReportArticleUrl,
  importMediaReportArticleUrl,
  systemMediaTypeUrl,
  checkTenantIndustryTopicListUrl,
  subNewsAllContentClassifyAndUserUrl,
  checkHotspotNewsListUrl,
  checkMediaAccountListUrl,
  checkMatrixNewsListUrl,
  exportClueNewsListUrl,
  exportMatrixNewsListUrl,
  subNewsAddOrCancelcollect,
  subNewsFindCollectUrl,
  exportCollectNewsListUrl,
  searchVideoAccountUrl,
};
